import { getIdToken } from "lib/amplify/getIdToken";

export const createAuthHeaders = async (endpoint: string): Promise<Headers> => {
  try {
    const idToken = await getIdToken(endpoint.includes("token"));
    const tokenString = `Bearer ${idToken}`;

    const authHeaders = new Headers({
      Accept: "application/json",
      Authorization: tokenString
    }); // TODO: Investigate extra headers

    return authHeaders;
  } catch {
    return new Headers();
  }
};
